import { usePaletteA } from '../charts.helper';

export const fill = ({ serieIndex }) => `${usePaletteA(serieIndex)}44`;
export const stroke = ({ serieIndex }) => usePaletteA(serieIndex);
